import { usePage } from 'Shared/frontend/PageProvider';
import {createContext,useContext} from 'solid-js';

/* A leaf object containing CSS properties */
export type CSS = any;

export interface ITheme {
	footer: {
		divider: any,
		title: any
	},
	poster: {
		backgroundColor: string,
		dateBar: any,
		photoPoster: {
			inlineName: any
		},
		detailsButton: {
			textColor: string,
			backgroundColor: string  
		}
	},
	nav: {
		desktop: {
			active:any,
			hover:any
		},
		mobile: {
			button: any,
			active:any,
			hover:any
		}
	},
	widgets: { 
		slideshow: {
			teaser: CSS
		},
	},
	events: {
		heading: {
			color: string
		}
	},
	event: {
		heading: any,
		artist: {
			heading: any,
			wide: any,
			narrow: {
				nameAndTime: any
			}, 
			genresAndLocation: any
		}
	},
	contact: {
		heading: {
			color: string
		}
	},
	//XXX except marginLeft & marginRight in main (double as settings)
	main: CSS,
	a: any,
	heading: any,
	button: any,
	subNavButton: any,
	list: any,
	definitions: any,
	blockquote: any,
	embeddedHtml: any,
}


const ThemeContext = createContext();

export function ThemeProvider(props:{theme:ITheme}) 
{
	return (
		<ThemeContext.Provider value={props.theme}>
			{props.children}
		</ThemeContext.Provider>
	);
}

export function theme():ITheme
{
	return useContext(ThemeContext);
}

export function palette()
{
	return useContext(ThemeContext).palette;
}

export function fonts()
{
	return useContext(ThemeContext).fonts;
}

export function sizes()
{
	return useContext(ThemeContext).sizes;
}

export function pageSetting(setting:string)
{
	return theme()[usePage().data.settingsPageName]?.[setting] ?? theme()[setting];
}

